import Ajax from '@/lib/ajax'
export default {
  /**
   * 创建直播间
   */
  createLiveRoom(data: any) {
    return Ajax.post(`/api/productManagement/room`, data)
  },
  /**
   * 获取直播间列表
   */
  getLiveRoomList(pageSize: number, currentPage: number) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
    }
    return Ajax.get('/api/productManagement/room', {
      params: params,
    })
  },
  liveRoomPushToWechat(id: string) {
    return Ajax.put(`/api/productManagement/room/PushAsync/${id}`)
  },

  /**
   * 获取直播间二维码
   */
  getQrCode(id: string) {
    return Ajax.get(`/api/WeChatManagement/WeChatRoom/GetQrCode/${id}`)
  },

  /**
   * 根据id获取直播间信息
   */
  getLiveRoomInfoById(id: string) {
    return Ajax.get(`/api/productManagement/room/${id}`)
  },
  /**
   * 根据id修改直播间信息
   */
  updatedLiveRoomInfoById(id: string, data: any) {
    return Ajax.put(`/api/productManagement/room/UpdateAsync/${id}`, data)
  },
  /**
   * 根据id推送到微信
   */
  pushAsyncById(id: string) {
    return Ajax.put(`/api/productManagement/room/PushAsync/${id}`)
  },
  /**
   * 根据id删除直播间信息
   */
  deleteLiveRoomInfoById(id: string) {
    return Ajax.delete(`/api/productManagement/room/${id}`)
  },
  /**
   * 根据id获取直播间统计
   */
  getStatisReportById() {
    return Ajax.get
  },
  /**
   * 获取直播间商品
   */
  getLiveRoomCommodityList(
    pageSize: number,
    currentPage: number,
    isEffective?: boolean,
    name?: string,
    type?: string
  ) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      AditSatusType: type,
      isEffective,
      name,
    }
    return Ajax.get(`/api/productManagement/wechatproduct`, {
      params: params,
    })
  },

  /**
   * 获取推送直播间商品
   */
  getPushRoomCommodityList(
    pageSize: number,
    currentPage: number,
    name?: string,
    code?: string,
    roomId?: string
  ) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      Code: code,
      name,
      roomId,
    }
    return Ajax.get(`/api/productManagement/roomproduct`, {
      params: params,
    })
  },

  /**
   * 直播间商品推送
   */
  pushGoods(id: string, data: any) {
    return Ajax.post(
      `/api/productManagement/roomproduct/UploadGoods/${id}`,
      data
    )
  },

  /**
   * 直播间商品推送
   */
  onSaleGoods(ids: any, roomId: string, onSale: number) {
    return Ajax.post(`/api/productManagement/roomproduct/OnSale`, {
      ids: ids,
      roomId: roomId,
      onSale: onSale,
    })
  },

  /**
   * 直播间关联商品选取
   */
  selectGoodsByRelated(data: any) {
    return Ajax.post(`/api/productManagement/roomproduct`, data)
  },
  /**
   * 直播间商品库添加直播商品选取功能
   */
  selectGoodsByMyGoodsList(data: any) {
    return Ajax.post(`/api/productManagement/wechatproduct`, data)
  },
  /**
   * 根据id修改直播商品信息
   */
  updatedGoodsInfoById(id: string, data: any) {
    return Ajax.put(`/api/productManagement/wechatproduct/${id}`, data)
  },
  /**
   * 根据id获取直播间商品信息
   */
  getLiveGoodsInfoById(id: string) {
    return Ajax.get(`/api/productManagement/wechatproduct/${id}`)
  },
  /**
   * 根据id删除直播商品
   */
  deleteGoodsById(id: string) {
    return Ajax.delete(`/api/productManagement/wechatproduct?id=${id}`)
  },

  /**
   * 根据id删除直播间商品
   */
  deleteRoomProduct(id: string) {
    return Ajax.delete(`/api/productManagement/roomproduct/${id}`)
  },
  /**
   * 提交到微信
   */
  pushWechatById(id: string) {
    return Ajax.get(`/api/productManagement/wechatproduct/Push/${id}`)
  },
  /**
   * 撤回直播商品提交申请
   */
  reCallWechatById(id: string) {
    return Ajax.get(`/api/productManagement/wechatproduct/ReCall/${id}`)
  },
  /**
   * 重新提交审核
   */
  rePushWechatById(id: string) {
    return Ajax.get(`/api/productManagement/wechatproduct/RePush/${id}`)
  },
  /**
   * 更新商品信息
   */
  reUpdateWechatById(id: string) {
    return Ajax.get(`/api/productManagement/wechatproduct/ReUpdate/${id}`)
  },
  /**
   * 获取优惠券列表
   */
  getCouponList(
    pageSize: number,
    currentPage: number,
    KeyWord?: string,
  ) {
    let params = {
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize,
      KeyWord
    }
    return Ajax.get(`/api/MarketingManagement/coupon`, {
      params
    })
  }
}
